// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ICreateCardRequestModel {
    static getAttributeTypeMap() {
        return ICreateCardRequestModel.attributeTypeMap;
    }
}
ICreateCardRequestModel.discriminator = undefined;
ICreateCardRequestModel.attributeTypeMap = [
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "newMemberNumbers",
        "baseName": "newMemberNumbers",
        "type": "number"
    }
];
//# sourceMappingURL=iCreateCardRequestModel.js.map